import "core-js/modules/es6.symbol.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions, mapMutations } from 'vuex';
import pickBy from 'lodash/pickBy';
import isNil from 'lodash/isNil';
import defer from 'lodash/defer';
import shallowEqualObjects from 'shallow-equal/objects';
import categoryTcVars from '~/modules/tagCommander/categoryTcVars';
import registerStoreModule from '~/helpers/store-helper';
import search from '~/store/modules/search';
import pageActions from '~/store/modules/pageActions';
import { extractCategoryFilterByFromQuery, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractCategoryQueryFromFilterBy, extractSelectedFilters } from '~/helpers/extract-helper';
import { extractCategoryQueryFromFilterBy as extractAlgoliaCategoryQueryFromFilterBy, extractCategoryFilterByFromQuery as extractAlgoliaCategoryFilterByFromQuery, extractSelectedFilters as extractAlgoliaSelectedFilters } from '~/helpers/algolia-extract-helper';
import getCorvusProviderName from '~/helpers/search-data-helpers';
export default {
  name: 'ResultsDataProvider',
  mixins: [categoryTcVars],

  data() {
    return {
      loadingProducts: true,
      loadingNextPage: false,
      loadingPreviousPage: false,
      unwatchSearchQuery: null,
      unwatchNextPage: null,
      unwatchPreviousPage: null
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    description: 'search/description',
    products: 'search/products',
    productsCount: 'search/productsCount',
    filterBy: 'pageActions/filterBy',
    orderBy: 'pageActions/orderBy',
    sortBy: 'pageActions/sortBy',
    previousPage: 'pageActions/previousPage',
    nextPage: 'pageActions/nextPage',
    sortReplica: 'search/algoliaReplica'
  })), {}, {
    isAlgoliaProvider() {
      return getCorvusProviderName(this) === 'algolia';
    },

    updateFilterBy() {
      var updated = {};

      if (this.description) {
        var filtersUpdated = extractAlgoliaSelectedFilters(this.filterBy, this.description.filters);
        updated = filtersUpdated.reduce((acc, filters) => {
          if (filters.label) {
            if (Object.keys(acc).indexOf(filters.filter) === -1) {
              return _objectSpread(_objectSpread({}, acc), {}, {
                [filters.filter]: [filters.facet]
              });
            }

            acc[filters.filter].push(filters.facet);
          }

          return acc;
        }, {});
      }

      return updated;
    },

    categoryQuery() {
      if (this.isAlgoliaProvider) {
        var filtersUpdated = this.updateFilterBy;
        return _objectSpread(_objectSpread({}, extractAlgoliaCategoryQueryFromFilterBy(filtersUpdated)), {}, {
          sort: this.sortBy,
          order: this.orderBy
        });
      }

      return _objectSpread(_objectSpread({}, extractCategoryQueryFromFilterBy(this.filterBy)), {}, {
        sort: this.sortBy,
        order: this.orderBy
      });
    },

    breadcrumb() {
      var breadcrumb = this.description.breadcrumb || [];
      return breadcrumb.map(entry => ({
        label: entry.title,
        url: "/".concat(this.locale.market, "/").concat(this.locale.language)
      }));
    },

    selectedFilters() {
      if (this.isAlgoliaProvider) {
        return this.description ? extractAlgoliaSelectedFilters(this.filterBy, this.description.filters) : false;
      }

      return this.description ? extractSelectedFilters(this.filterBy, this.description.filters) : false;
    },

    currentPath() {
      return this.description ? "".concat(this.baseURL).concat(this.buildSearchUrl(this.locale, this.description.query)) : false;
    },

    pageTitle() {
      var _ref, _ref2;

      var replacement = {
        x: this.productsCount,
        y: (_ref2 = this.description) != null ? _ref2.query : _ref2,
        z: (_ref = this.description) != null ? _ref.suggest_query : _ref
      };
      var tradName = 'searchTitle';

      if (!this.productsCount) {
        tradName = 'searchTitleNoResults';
      } else if (this.description.is_corrected) {
        tradName = 'searchTitleCorrect';
      } else if (this.description.suggest_query) {
        tradName = 'searchTitleSuggest';
      }

      return this.$i18n.tc(tradName, this.productsCount, replacement);
    },

    isSearchQueryAlgolia() {
      return this.$route.query.query;
    }

  }),

  created() {
    registerStoreModule(this.$store, 'search/', search);
    registerStoreModule(this.$store, 'pageActions/', pageActions);

    if (process.client) {
      var {
        params: {
          keyword
        },
        query
      } = this.$route;
      var args = {
        keyword,
        query
      };
      this.resetPagination();
      this.resetFilters();
      this.resetSearch();
      this.setDefaultFilterBy(extractCategoryFilterByFromQuery(query));

      if (this.isAlgoliaProvider) {
        this.setDefaultFilterBy(extractAlgoliaCategoryFilterByFromQuery(query));
      }

      this.setDefaultSortBy(extractCategorySortByFromQuery(query));
      this.setDefaultOrderBy(extractCategoryOrderByFromQuery(query));
      this.setPreviousPage(extractCategoryPreviousPageFromQuery(query));
      this.setNextPage(extractCategoryNextPageFromQuery(query));

      try {
        this.fetchSearch(args).then(() => {
          this.loadingProducts = false;
          this.scrollBackToProduct(localStorage.getItem('currentProduct'));
          this.setTcVars();
          localStorage.removeItem('currentProduct');
        });
      } catch (error) {
        this.$logger.error(error);
      }
    }
  },

  mounted() {
    var _this = this;

    return _asyncToGenerator(function* () {
      _this.unwatchSearchQuery = _this.$watch('categoryQuery', /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(function* (oldVal, newVal) {
          if (!shallowEqualObjects(oldVal, newVal)) {
            _this.loadingProducts = true;
            yield _this.handleWatcher(_this.fetchSearch, 1);

            _this.resetPagination();

            _this.loadingProducts = false;
          }
        });

        return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());
      _this.unwatchNextPage = _this.$watch('nextPage', /*#__PURE__*/_asyncToGenerator(function* () {
        var predicate = _this.nextPage === 1 && _this.previousPage === 1;

        if (!predicate) {
          _this.loadingNextPage = true;
          yield _this.handleWatcher(_this.appendProducts, _this.nextPage);
          _this.loadingNextPage = false;
        }
      }));
      _this.unwatchPreviousPage = _this.$watch('previousPage', /*#__PURE__*/_asyncToGenerator(function* () {
        var predicate = _this.nextPage === 1 && _this.previousPage === 1;

        if (!predicate) {
          _this.loadingPreviousPage = true;
          yield _this.handleWatcher(_this.prependProducts, _this.previousPage);
          _this.loadingPreviousPage = false;
        }
      }));
    })();
  },

  beforeDestroy() {
    this.unwatchSearchQuery();
    this.unwatchNextPage();
    this.unwatchPreviousPage();
  },

  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations({
    setDefaultFilterBy: 'pageActions/SET_DEFAULT_FILTERBY',
    setDefaultSortBy: 'pageActions/SET_DEFAULT_SORTBY',
    setDefaultOrderBy: 'pageActions/SET_DEFAULT_ORDERBY',
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE',
    resetPagination: 'pageActions/RESET_PAGINATION',
    resetFilters: 'pageActions/RESET_FILTERS',
    resetSearch: 'search/RESET_SEARCH'
  })), mapActions({
    fetchSearch: 'search/fetchContent',
    appendProducts: 'search/appendProducts',
    prependProducts: 'search/prependProducts'
  })), {}, {
    handleWatcher(handler, page) {
      var _this2 = this;

      return _asyncToGenerator(function* () {
        var {
          params: {
            keyword
          }
        } = _this2.$route;

        var query = _objectSpread(_objectSpread({}, _this2.categoryQuery), {}, {
          page
        });

        try {
          yield handler({
            query,
            keyword
          });

          _this2.$router.push({
            query: pickBy(query, e => !isNil(e))
          });

          if (!_this2.isSearchQueryAlgolia) _this2.setTcVars();
        } catch (err) {
          _this2.$logger.error(err);
        }
      })();
    },

    scrollBackToProduct(arg) {
      if (arg) {
        var currentProduct = JSON.parse(arg);
        defer(() => {
          var product = document.getElementById(currentProduct);

          if (product) {
            window.scrollTo({
              top: product.offsetTop
            });
          }
        });
      }
    }

  }),

  render() {
    return this.$scopedSlots.default({
      nextPage: this.nextPage,
      previousPage: this.previousPage,
      loadingNextPage: this.loadingNextPage,
      loadingPreviousPage: this.loadingPreviousPage,
      loadingProducts: this.loadingProducts,
      products: this.products,
      productsCount: this.productsCount,
      breadcrumb: this.description ? this.breadcrumb : false,
      selectedFilters: this.selectedFilters,
      currentPath: this.currentPath,
      description: this.description,
      filters: this.description ? this.description.filters : false,
      pageTitle: this.pageTitle
    });
  }

};